import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// If a div has html dyn-binding it's treated as a text block. Should be formalized by ensuring node.data.text is present
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}, tag} = jsonNode;
  const hasDynBoundHtml = DomTypeUtils.isDynBoundHtml(data);

  return {
    needed:
      hasDynBoundHtml &&
      tag === 'div' &&
      !data.text &&
      !DomTypeUtils.isRichBlock(tag, data) &&
      !DomTypeUtils.isVideo(data),
    logData: {
      msg: 'DynBoundHtml text block missing node.data.text',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.text = true;
    },
  };
};
